import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  MessageBox,
  useTitle,
  MotionDiv,
  CustomTable,
  ViewButton,
  DeleteButton,
} from "../../components";
import { getError, toastOptions } from "../../utils/error";
import { useDispatch, useSelector } from "react-redux";
import { hideLoading, showLoading } from "../../features/loadingSlice";
import axiosInstance from "../../utils/axiosUtil";
import { Col, Row } from "react-bootstrap";
import CountCard from "../../components/layout/CountCard";
import { EditButton } from "../../components/layout/CustomTable";
import { selectAuth } from "../../features/authSlice";
import { useGetSubdomainsMutation } from "../../features/apiSlice";
import { fetchSubdomains } from "../../utils/apis";

export default function Plans() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { accessToken } = useSelector(selectAuth);
  const [getSubdomains, { isLoading }] = useGetSubdomainsMutation();

  // const [users,setUsers] = useState([]);
  const [usersCount, setUsersCount] = useState([]);
  const [curPage, setCurPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [query, setQuery] = useState("");
  const [subdomains, setSubdomains] = useState([]);
  const [amountRecieved, setAmountRecieved] = useState(0);
  const [monthlyAmountRecieved, setMonthlyAmountRecieved] = useState(0);
  const [numberOfSubscription, setNumberOfSubscription] = useState(0);
  const [monthlySubscription, setMonthlySubscription] = useState(0);

  const curPageHandler = (p) => setCurPage(p);

  const fetchSubdomains = async (id = null) => {
    try {
      const data = await getSubdomains({ id, params: `getProfessorData=false&key=${query}` }).unwrap();
      // console.log(data);
      setSubdomains(data?.subDomains);
      setAmountRecieved(data?.totalAmountReceived);
      setMonthlyAmountRecieved(data?.monthlyAmount);
      setNumberOfSubscription(data?.totalTransaction);
      setMonthlySubscription(data?.monthlyTransaction);
    } catch (error) {
      getError(error);
    }
  };

  useEffect(() => {
    fetchSubdomains();
    //   {
    //   setSubdomains,
    //   id: null,
    //   getSubdomains,
    //   params: query,
    // }
    // setAmountRecieved(data.totalAmountReceived);
    // setNumberOfSubscription(data.totalTransaction);
  }, [query]);

  const numOfPages = Math.ceil(usersCount / resultPerPage);
  const skip = resultPerPage * (curPage - 1);
  // console.log("no of Page", numOfPages, resultPerPage, usersCount);

  const column = [
    "No.",
    "Specialty",
    "Web Domain URL",
    //"Prof. Alloted",
    <>
      <span>Plans Available</span>
      <br />
      <span style={{ color: "var(--main-blue)", fontSize: "0.9rem" }}>
        M | Q | S | Y 
      </span>
    </>,
    "Actions",
  ];

  return (
    <MotionDiv>
      <Row>
        <CountCard
          title={"Total Amount Received"}
          // count={`£${amountRecieved}`}
          monthValue={`£${monthlyAmountRecieved || 0}`}
          yearValue={`£${amountRecieved || 0} `}
          dropdown={true}
          color="var(--green-color)"
        />
        <CountCard
          title={"No. of Subscriptions"}
          // count={numberOfSubscription}
          monthValue={monthlySubscription || 0}
          yearValue={numberOfSubscription || 0}
          dropdown={true}
          color="var(--purple-color)"
        />
        {/* <CountCard title={'New Subscription Added'} count={5450}/> */}
      </Row>

      <CustomTable
        loading={isLoading}
        column={column}
        rowNo={resultPerPage}
        rowProps={{ setResultPerPage }}
        paging={numOfPages > 0}
        pageProps={{ numOfPages, curPage }}
        pageHandler={curPageHandler}
        search={true}
        searchProps={{ query, setQuery }}
        isTitle="true"
        title="Domain Plan Details"
      >
        {subdomains &&
          subdomains?.map((data, i) => (
            <tr key={data?._id} className="odd">
              <td className="text-center">{skip + i + 1}</td>
              <td>{data?.sub_domain_name}</td>
              <td>{data?.domain_url}</td>
{/* <td>
                {data?.professor?.length > 0
                  ? data?.professor?.map((prof) => prof.first_name + ' ' + prof?.last_name).join(" | ")
                  : "NA"}
              </td> */}
              <td
                className="text-center"
                style={{ color: "rgba(97, 114, 243, 1)" }}
              >
               {['Monthly', 'Quarterly', 'SemiAnnual', 'Annually'].map((type, i, arr) => {
  const plan = data?.plans?.find(p => p?.validity === type);
  return plan ? (
    <span key={plan._id}>
      {data?.currencySymbol}{plan.price}
      {i < arr.length - 1 && ' | '}
    </span>
  ) : null;
})}

              </td>
              <td className="text-center">
                <EditButton
                  onClick={() =>
                    navigate(`/admin/domains/edit-specialty/${data?._id}`)
                  }
                />
                {/* <ViewButton
                  onClick={() => navigate(`/admin/manage-plans/view`)}
                /> */}
                {/* <DeleteButton
                  onClick={() => {
                    //  deleteUser(user?._id)
                    console.log("deleted");
                  }}
                /> */}
              </td>
            </tr>
          ))}
      </CustomTable>
    </MotionDiv>
  );
}
